export const noPropertyError = 'Error no property';
